<template>
  <v-container>
    <v-card>
      <v-card-title>
        <!-- <span class="headline">Person Details</span> -->
       Person Details
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            v-if="Testing"
            v-model="editedItem.username"
            dense
            outlined
            label="OUG User"
            @blur="LookupUser"
          ></v-text-field>
        </v-col>
      </v-card-title>
      <v-card-text>
          <v-form ref="Person" v-model="personValid" lazy-validation>
            <v-row dense no-gutters>
              <v-col cols="12">
                <h4 style="color: red">{{ error }}</h4>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="editedItem.ticket"
                  :items="Tickets"
                  outlined
                  dense
                  label="Select your Ticket Type"
                  :rules="[(v) => !!v || 'Ticket Type is required']"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.person"
                  label="Person Name"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Your Name is required']"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.phone"
                  label="Mobile Ph #"
                  v-mask="'####-###-###'"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Phone # is required']"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.email"
                  label="Email Address"
                  outlined
                  dense
                  :rules="[rules.required, rules.email]"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="editedItem.photoReg"
                  :label="`I am taking Photos of games`"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.photoPlayer"
                  label="Name of Player you will be taking photos of"
                  outlined
                  dense
                  :rules="[rules.photoDetail, rules.counter]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn color="oug" text @click="close">
          <v-icon>mdi-close-circle-outline</v-icon>
          Cancel
        </v-btn>
         <v-spacer></v-spacer>
        <v-btn color="oug" text @click="save"
          >Save
          <v-icon>mdi-content-save-outline</v-icon>
        </v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog v-model="lookup" hide-overlay persistent width="300">
      <v-card color="#962283" dark>
        <v-card-text>
          Checking OwnUrGoal - Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import db from "../data/Database";
import axios from "axios";

export default {
  name: "People",
  data() {
    return {
      Testing: false,
      currentState: null,
      retView: this.$route.params.retView,
      people: [],
      Tickets: ["Adult", "Child (6-17)", "Infant (under 6)"],
      personValid: true,
      dialog: true,
      editedIndex: -1,
      editedItem: {
        contact_id: 0,
        username: "",
        ticket: "",
        person: "",
        phone: "",
        email: "",
        photoReg: "",
        photoPlayer: "",
      },
      defaultItem: {
        contact_id: 0,
        username: "",
        ticket: "",
        person: "",
        phone: "",
        email: "",
        photoReg: "",
        photoPlayer: "",
      },
      lookup: false,
      error: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        photoDetail: (value) => {
          return (this.editedItem.photoReg ? !!value : true) || "Required.";
        },
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  created() {
    db.currentState.get(1, (result) => this.loadPerson(result));
  },
  methods: {
    loadPerson(result) {
      this.Testing = (result.Parameters && result.Parameters.testing && result.Parameters.testing == 'true') ? true : false
      db.people.get(result.selectedPerson, (result) => this.LoadPersonDetail(result));
    },
    LoadPersonDetail(result) {
      result ? (this.editedItem = result) : (this.dialog = true);
    },
    LookupUser() {
      // Look up a username
      if (this.editedItem.username) {
        this.lookup = true;
        this.error = "";
        const baseURL =
          "https://server.ownurgoal.net.au/auth/Lookup_Username/" +
          this.editedItem.username;
        axios
          .get(baseURL)
          .then((response) => {
            this.editedItem.contact_id = response.data.result[0].Contact_id;
            this.editedItem.person = response.data.result[0].Person;
            this.editedItem.phone = response.data.result[0].Phone;
            this.editedItem.email = response.data.result[0].Email;
            this.editedItem.photoReg = "";
            this.editedItem.photoPlayer = "";
            this.lookup = false;
          })
          .catch((error) => {
            this.editedItem.contact_id = 0;
            this.editedItem.username = "";
            this.editedItem.person = "";
            this.editedItem.phone = "";
            this.editedItem.email = "";
            this.editedItem.photoReg = "";
            this.editedItem.photoPlayer = "";
            this.lookup = false;
            console.log(error);
            this.error = "Username not found on OwnUrGoal";
          });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$router.push(`/${this.retView}`);
    },
    save() {
      if (this.$refs.Person.validate()) {
        db.people.put(this.editedItem);
        this.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
